module.exports = __webpack_public_path__ + "img/education4.d799de2a.png";